import React, { useState } from 'react';
import ProfileSettings from './ProfileSettings';
import StoreDetails from './StoreDetails';
import SecuritySettings from './SecuritySettings';
import Customization from './PanelCustomization'; 
import BackupSettings from './BackupSettings'; 
import GetSupport from './GetSupport'; 
import styles from './Setting.module.css';

const Setting = () => {
  const [adminInfo, setAdminInfo] = useState({
    name: '',
    email: '',
    profilePicture: '',
  });

  const [storeInfo, setStoreInfo] = useState({
    storeName: 'Store Name',
    storeAddress: 'Store Address, City, Country',
    pinCode: '',
    state: '',
    businessType: '',
    businessDetail: '',
  });

  const [isEditing, setIsEditing] = useState(false);
  const [activeSection, setActiveSection] = useState('profile');
  const [theme, setTheme] = useState('light');
  const [backupStatus, setBackupStatus] = useState('Not Started');
  const [language, setLanguage] = useState('en');

  const handleSectionClick = (section) => {
    setActiveSection(section);
  };

  return (
    <div className={`${styles.container} ${theme === 'dark' ? styles.darkMode : ''}`}>
      <div className={styles.sidebar}>
        <div
          className={`${styles.section} ${activeSection === 'profile' ? styles.activeSection : ''}`}
          onClick={() => handleSectionClick('profile')}
        >
          Profile
        </div>
        {/* <div
          className={`${styles.section} ${activeSection === 'storeDetail' ? styles.activeSection : ''}`}
          onClick={() => handleSectionClick('storeDetail')}
        >
          Store Details
        </div>
        <div
          className={`${styles.section} ${activeSection === 'security' ? styles.activeSection : ''}`}
          onClick={() => handleSectionClick('security')}
        >
          Security Settings
        </div>
        <div
          className={`${styles.section} ${activeSection === 'customization' ? styles.activeSection : ''}`}
          onClick={() => handleSectionClick('customization')}
        >
          Panel Customization
        </div>
        <div
          className={`${styles.section} ${activeSection === 'backup' ? styles.activeSection : ''}`}
          onClick={() => handleSectionClick('backup')}
        >
          Backup
        </div>
        <div
          className={`${styles.section} ${activeSection === 'support' ? styles.activeSection : ''}`}
          onClick={() => handleSectionClick('support')}
        >
          Get Support
        </div> */}
      </div>

      <div className={styles.content}>
        {activeSection === 'profile' && <ProfileSettings adminInfo={adminInfo} setAdminInfo={setAdminInfo} isEditing={isEditing} setIsEditing={setIsEditing} />}
        {activeSection === 'storeDetail' && <StoreDetails storeInfo={storeInfo} setStoreInfo={setStoreInfo} isEditing={isEditing} setIsEditing={setIsEditing} />}
        {activeSection === 'security' && <SecuritySettings />}
        {activeSection === 'customization' && <Customization theme={theme} setTheme={setTheme} language={language} setLanguage={setLanguage} />}
        {activeSection === 'backup' && <BackupSettings backupStatus={backupStatus} setBackupStatus={setBackupStatus} />}
        {activeSection === 'support' && <GetSupport />} 
      </div>
    </div>
  );
};

export default Setting;
